// The Content-Type a storage upload carries, made one the bucket accepts.
//
// Supabase refuses a type outside the bucket's allow-list with a 400 that is
// never retried. `covers` and `app-assets` list image/jpeg but not image/jpg,
// and no bucket takes application/octet-stream — yet browsers report all of
// them for a valid JPEG: image/jpg or the legacy image/pjpeg from a Windows
// registry, and an empty type (iOS Files, some Android pickers) that the
// transport used to send as octet-stream. One place fixes the label; the
// bytes are never touched.
//
// Guard: src/lib/uploadContentType.test.ts

const ALIASES: Record<string, string> = {
  'image/jpg': 'image/jpeg',
  'image/pjpeg': 'image/jpeg',
  'image/x-citrix-jpeg': 'image/jpeg',
  'image/x-png': 'image/png',
  'image/x-citrix-png': 'image/png',
};

const BY_EXTENSION: Record<string, string> = {
  jpg: 'image/jpeg', jpeg: 'image/jpeg', jpe: 'image/jpeg', jfif: 'image/jpeg',
  png: 'image/png', webp: 'image/webp', gif: 'image/gif',
  heic: 'image/heic', heif: 'image/heif',
  mp4: 'video/mp4', mov: 'video/quicktime',
  pdf: 'application/pdf',
};

/** The type to send for this file: a known alias corrected, a missing one read off the name. */
export function uploadContentType(type: string | null | undefined, name: string | null | undefined): string {
  const t = String(type ?? '').trim().toLowerCase();
  if (ALIASES[t]) return ALIASES[t];
  if (t && t !== 'application/octet-stream') return t;
  const n = String(name ?? '');
  const dot = n.lastIndexOf('.');
  const ext = dot >= 0 ? n.slice(dot + 1).trim().toLowerCase() : '';
  return BY_EXTENSION[ext] ?? 'application/octet-stream';
}
